<template>
    <div class="vacancy-slider">
        <div class="swiper-container swiper js-vacancy-slider">
            <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="(card, index) in cardList" :key="card.id">
                    <z-card
                        theme="vacancy"
                        class="js-content--sticky"
                        :href="card.detailPageUrl"
                        :is-background-image="false"
                        :content-data="{
                                title: card.name,
                                tags: card.type.value,
                                schedule: card?.schedule?.value
                            }"
                        is-shift-tag
                        :is-fire-tag="card.hot.value === 'Y'"
                    >
                    </z-card>
                </div>
            </div>
        </div>
    </div>

</template>
<script setup>
import {onMounted, onUnmounted } from "vue";
import ZCard from "@/components/ZCard/"
import Swiper from 'swiper/swiper-bundle.mjs';

defineProps({
    cardList: {
        type: Array,
        default: [],
    }
})
let vacancySliderEl;
onMounted(() => {
    vacancySliderEl = document.querySelector('.js-vacancy-slider')
    const swiper = new Swiper(vacancySliderEl, {
        direction: 'vertical',
        speed: 700,
        grabCursor: true,
        centeredSlides: true,
        watchSlidesProgress: true,
        loop: true,
        followFinger: false,
        effect: 'cards',
        cardsEffect: {
            perSlideOffset: 15,
            perSlideRotate: 0,
            slideShadows: false,
        },
    })
    vacancySliderEl.addEventListener('wheel', (e) => {
        e.preventDefault()
        if (e.wheelDeltaY < 0) {
            swiper.slideNext()
        } else {
            swiper.slidePrev()
        }
    });
})
onUnmounted(() => {
    vacancySliderEl.removeEventListener('wheel')
})
</script>

<style lang="scss" scoped>
.vacancy-slider {

    @include breakpoint(mobile) {
        margin-top: 0;
        padding-top: 0;
    }

    & .swiper {
        height: 330px;
        max-height: 330px;
        overflow: visible;

        & .swiper-slide {
            &:not(.swiper-slide-active) {
                & .z-card {
                    filter: blur(2.5px);
                    opacity: 0.9;
                }
            }

            & .z-card {
                filter: blur(0);
                opacity: 1;
                transition: all .4s ease-in-out;
            }
        }
    }
}
</style>
